import React from "react"
import {Form, Field, Formik} from "formik";
import ApiService from "../../../Services/ApiService";
import CampaignService from "../../../Services/CampaignService";
import AlertService from "../../../Services/AlertService";

class Budget extends React.Component {
    state = {
        data: {
            campaign_id: "",
            client_id: "",
            client_name: "",
            linkedin_company_id: "",
            daily_budget: "250.00",  //always default to 250
            total_budget: "250.00",
            campaign_total_budget: "",
            engagement_clicks: "",
            bid_type: "",
            bid_strat: "",
            optimization_type: "",
            bid_amount: "20.00",
            conversion_trackings: [],
            enable_notifications: false,

        },
        available_trackings: []

    };


    componentDidMount() {
        if (this.props.data) {
            this.setBidAndConversions(this.props.data.campaignId);
        }
    }

    setBidAndConversions(campaign_id) {
        const url = "/api/campaigns/fetch?campaign_id=" + campaign_id;
        ApiService.get(url)
            .then(response => {
                let campaign = response.data.Campaign;
                if (campaign) {

                    this.setBidFields(campaign.bid_type, campaign.objective_type, campaign.bid_strat);
                    this.setState({
                        ...this.state,
                        data: campaign
                    }, () => {
                        this.setConversionTrackings();
                    })
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    setConversionTrackings() {
        const url = "/api/linkedin/conversion-trackings?client_id=" + this.props.data.clientId;

        ApiService.get(url)
            .then(response => {
                if (!('serviceErrorCode' in response.data)) {
                    let trackings = response.data;
                    let trackingNames = trackings.map(tracking => tracking.name);
                    this.setState({...this.state.data, available_trackings: trackingNames})
                }

            });

    }

    save(values) {
        // unset categories to avoid accidentally changing its value since it cannot be
        // changed on the budget page
        delete values['categories'];
        this.updateCampaign(values)
            .then(response => {
                console.log(response);
                AlertService.success('Campaign saved successfully');
            })
            .catch(error => {
                AlertService.error('Oops! There was an error saving the Campaign');
            })

    }

    handleChange(e) {
        const {name, value} = e.target;

        if (name === 'bid_type') {
            this.handleBidTypeChange(value, this.state.data.objective_type);
        } else if (name === 'conversion_optimization') {
            let enableOptimization = e.target.checked ? 1 : 0;
            this.setState({data: {...this.state.data, [name]: enableOptimization}}
            )
        } else if (name === 'bid_strat') {
            this.handleBidTypeChange(this.state.data.bid_type, this.state.data.objective_type);
            this.setState({data: {...this.state.data, [name]: value}})
        } else {
            this.setState({data: {...this.state.data, [name]: [value]}})
        }

    }

    updateCampaign(values) {
        let data = JSON.parse(JSON.stringify(values));
        data['campaign_status_id'] = CampaignService.getStatusId(data.status);
        data['audience_network'] = data['audience_network'] ? 1 : 0;
        data['campaign_objective_type_id'] = CampaignService.getObjectiveTypeId(data.objective_type);
        data['enable_notifications'] = this.state.data.enable_notifications ? 1 : 0;

        // remove unchanged image fields
        delete data['image_json_a'];
        delete data['image_json_b'];

        return new Promise((resolve, reject) => {
            ApiService.post("/api/campaigns/update", data)
                .then(response => {
                    if (response.data.Success) {
                        resolve(response);
                    } else {
                        reject(response);
                    }
                })
                .catch(error => {
                    reject(error);
                })
        })
    }

    handleBidTypeChange(bidType, objectiveType) {
        let bidStrat = document.getElementById('bid-strat').value;
        this.setBidFields(bidType, objectiveType, bidStrat);
        this.setState({
            data: {...this.state.data, bid_type: bidType}
        })
    }

    setBidFields(bidType, objectiveType, bidStrat) {

        let selectEl = document.getElementById('bid-type');
        let cpcOption = selectEl.options[0];
        let cpvOption = selectEl.options[2];

        if (objectiveType === 'BRAND_AWARENESS' || objectiveType === 'VIDEO_VIEW') {
            cpcOption.style.display = 'none';

        } else {
            cpcOption.style.display = 'block';
        }

        if (objectiveType === 'VIDEO_VIEW') {
            cpvOption.style.display = 'block';
        } else {
            cpvOption.style.display = 'none';
        }

        if (bidStrat === 'AUTO') {
            document.getElementById('bid-amount-section').style.display = 'none';
        } else {
            document.getElementById('bid-amount-section').style.display = 'block';
        }

    }

    isChecked(tracking) {
        return this.state.data.conversion_trackings.includes(tracking);
    }

    handleTrackingChange(event) {
        let trackingOption = event.target.value;
        let selectedOptions = this.state.data.conversion_trackings;
        if (event.target.checked) {
            selectedOptions.push(trackingOption);
        } else {
            let index = this.state.data.conversion_trackings.indexOf(trackingOption);
            if (index > -1) {
                selectedOptions.splice(index, 1);
            }
        }

        this.setState({...this.state.data, conversion_trackings: selectedOptions});


    }

    toggleEnableNotifications = () => {

        let enableNotifications = !this.state.data.enable_notifications;

        enableNotifications = enableNotifications ? 1 : 0;

        this.setState({
            data: {...this.state.data, enable_notifications: enableNotifications}
        })

    }

    render() {

        let trackingOptions = null;

        if (this.state.available_trackings && this.state.available_trackings.length > 0) {
            trackingOptions = (
                <div className="checkbox-container">
                    {this.state.available_trackings.map((job, index) =>
                        <label className="checkmark-container" key={index}>{job}
                            <input type="checkbox" checked={this.isChecked(job)} key={index} value={job}
                                   onChange={this.handleTrackingChange.bind(this)}/>
                            <span className="checkmark"> </span>
                        </label>
                    )}
                </div>
            )
        }

        return (
            <div className="page-main">

                <Formik
                    enableReinitialize
                    initialValues={this.state.data}
                    onSubmit={this.save.bind(this)}
                    render={({values, errors, touched, isSubmitting, handleBlur}) => {
                        return (
                            <Form className="form-container">
                                <div className="form-budget">
                                    <div className="form-col">
                                        <div className="input-group">
                                            <h3>Budget</h3>
                                            <label>
                                                <span>Campaign Group Total Budget </span>
                                                <Field
                                                    name="campaign_total_budget"
                                                    type="number" min="0"
                                                    onChange={this.handleChange.bind(this)}
                                                    value={values.campaign_total_budget}

                                                />

                                            </label>
                                        </div>

                                        <div className="space-between"></div>

                                        <div className="input-group">
                                            <label>
                                                <span>Daily Budget </span>
                                                <Field
                                                    name="daily_budget"
                                                    type="number" min="0"
                                                    onChange={this.handleChange.bind(this)}
                                                    value={values.daily_budget}

                                                />

                                            </label>
                                        </div>

                                        <div className="space-between"></div>

                                        <div className="input-group">
                                            <h3>Bidding</h3>
                                            <label>
                                                <span>Total Budget </span>
                                                <Field
                                                    name="total_budget"
                                                    type="number" min="0"
                                                    onChange={this.handleChange.bind(this)}
                                                    value={values.total_budget}
                                                />

                                            </label>
                                        </div>
                                        <div className="space-between"></div>

                                        <div className="input-group">
                                            <label>
                                                <span> Optimization goal</span>
                                                <Field
                                                    id="bid-type"
                                                    name="bid_type"
                                                    component="select"
                                                    values={values.bid_type}
                                                    onChange={this.handleChange.bind(this)}
                                                    className="option"
                                                >
                                                    <option value="CPC">Landing Page Clicks</option>
                                                    <option value="CPM">Impressions</option>
                                                    <option value="CPV">Video Views</option>

                                                </Field>
                                            </label>
                                        </div>

                                        <div className="space-between"></div>

                                        <div className="input-group">
                                            <label>
                                                <span> Bidding strategy </span>
                                                <Field
                                                    id="bid-strat"
                                                    name="bid_strat"
                                                    component="select"
                                                    values={values.bid_strat}
                                                    onChange={this.handleChange.bind(this)}
                                                    className="option"
                                                >
                                                    <option value="MANUAL">Manual bidding</option>
                                                    <option value="AUTO">Maximum delivery (Automated)</option>
                                                    <option value="TARGET">Target Cost</option>


                                                </Field>
                                            </label>
                                        </div>

                                        <div className="space-between"></div>

                                        <div id="bid-amount-section" className="input-group">
                                            <label>
                                                <span> Bid Amount</span>
                                                <Field
                                                    id="bid-amount"
                                                    name="bid_amount"
                                                    type="number" min="0"
                                                    values={values.bid_amount}
                                                    onChange={this.handleChange.bind(this)}
                                                >

                                                </Field>
                                            </label>
                                        </div>

                                        <h3>Conversion Tracking </h3>
                                        <div className="description">
                                            Measure the actions members take on your website after clicking or viewing
                                            your
                                            LinkedIn ad.

                                        </div>


                                        {trackingOptions}
                                    </div>
                                    <div className="form-col">
                                        <div className="input-group">
                                            <h3>Engagement Alerts</h3>
                                            <input  type="checkbox" className="checkbox-field" name="enable-notifications" checked={this.state.data.enable_notifications} onChange={() => this.toggleEnableNotifications()} />
                                            <span className="checkbox-label">Enable notifications to account owners</span>
                                            <div className="space-between"></div>
                                            <span># of Clicks</span>
                                            <label>
                                                <Field
                                                    name="engagement_clicks"
                                                    type="number"
                                                    onChange={this.handleChange.bind(this)}
                                                    value={values.engagement_clicks}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <hr width="1"></hr>
                                <div className="form-submit">
                                    <button type="submit">Save</button>
                                    <button type="button" className="outline"
                                            onClick={() => {
                                                this.props.history.push("/campaigns?client_id=" + this.state.data.client_id + "&client_name=" + this.state.data.client_name)
                                            }}>
                                        Cancel
                                    </button>
                                </div>
                            </Form>
                        )
                    }
                    }
                >
                </Formik>
            </div>
        )
    }
}

export default Budget